import {register} from '@shopify/theme-sections';

const selectors = {
  title: '[data-collection-header-title]',
};

export default register('collection-header', {
  onLoad() {
    const container = this.container;

    const collectionHeaderTitle = container.querySelector(selectors.title);
    if (collectionHeaderTitle) {
      // Reset the collection header title when the results grid is updated
      // (applies when add_page_to_title is enabled)
      document.addEventListener('results-grid:updated', () => {
        collectionHeaderTitle.textContent = collectionHeaderTitle.dataset.collectionHeaderTitle;
      });
    }
  },
});
